import { get, writable } from "svelte/store";

import LoadState from "../../Enums/LoadState";
import GeoHelper from "../../Helpers/GeoHelper";
import VisibilityState from "../../Map/Enums/VisibilityState";
import { Paint } from "../../Map/MapLayerStyles";
import MapStore from "../../Map/Store";

import MapLayerGroup from "../../Map/Enums/MapLayerGroup";
import MapLayerManager from "../../Map/MapLayerManager";

import API from "../../API/API";
import PopupStore from "../../Map/Popup/PopupStore";

const GNSSHotspotsStore = {
	config: {

	},
	meta: {
		loadState: writable(LoadState.INIT),
		layers: [],
		visible: writable(false),
		lastUpdated: writable(0),
		visibility: {
			gnss: writable(true)
		}
	},
	results: {
		gnss: writable(GeoHelper.emptyGeoJson())
	},
	actions: {
		init: () => {
			if (get(GNSSHotspotsStore.meta.loadState) !== LoadState.INIT) {
				return;
			}
			GNSSHotspotsStore.meta.loadState.set(LoadState.LOADING);
			console.log("Loading GNSS Hotspots...");

			API.get("datasets/aviation-gnss-hotspots").then((response) => {
				const results = JSON.parse(response.dataset.content);
				console.log("GNSS Hotspots", results);

				MapStore.helpers.addDataLayer("gnss_hotspots", "fill", {}, Paint.hotspots.orange, results, GNSSHotspotsStore.meta.layers);
				MapLayerManager.addLayerGroup(MapLayerGroup.GNSS_HOTSPOTS, [
					"gnss_hotspots"
				], [
					"gnss_hotspots"
				]);

				GNSSHotspotsStore.results.gnss.set(results);

				const setupPopups = (layer) => {
					const map = MapStore.helpers.getMap();
					const enter = (e) => {
						const coords = [e.lngLat.lng, e.lngLat.lat];
						const props = e.features[0].properties;
						PopupStore.actions.customHtml("<b>GNSS Hotspot</b>", 300, coords, true);
					};
					const move = enter;
					const leave = (e) => {
						PopupStore.actions.custom({}, null, false);
					};
					map.on("mouseenter", layer, (e) => {
						enter(e);
					});
					map.on("mousemove", layer, (e) => {
						move(e);
					});
					map.on("mouseleave", layer, (e) => {
						leave(e);
					});
				};
				setupPopups("gnss_hotspots");
				GNSSHotspotsStore.meta.loadState.set(LoadState.LOADED);
				GNSSHotspotsStore.meta.lastUpdated.set(Date.now());
			});
		},

		updateVisibility: () => {
			const map = MapStore.helpers.getMap();
			if (map) {
				if (get(GNSSHotspotsStore.meta.loadState) !== LoadState.LOADED) {
					return;
				}
				const visible = get(GNSSHotspotsStore.meta.visible);
				const gnssVisibility = get(GNSSHotspotsStore.meta.visibility.gnss);
				map.setLayoutProperty("gnss_hotspots", "visibility", (visible && gnssVisibility) ? VisibilityState.VISIBLE : VisibilityState.NONE);
			}
		}
	}
};

export default GNSSHotspotsStore;
